import { useSyncExternalStore } from 'react';

function getPath(): string {
  return window.location.pathname;
}

const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function notify(): void {
  for (const listener of listeners) listener();
}

window.addEventListener('popstate', notify);

export function navigate(path: string, options?: { replace?: boolean }): void {
  if (options?.replace) {
    window.history.replaceState(null, '', path);
  } else {
    window.history.pushState(null, '', path);
  }
  notify();
}

export function usePath(): string {
  return useSyncExternalStore(subscribe, getPath);
}

export function reportDetailPath(reportId: string): string {
  return `/report/${encodeURIComponent(reportId)}`;
}

export function settingsPath(): string {
  return '/settings';
}

export function uploadPath(): string {
  return '/upload';
}
